export const ProfileFieldTypes = {
  extension: 'Extension',
  codeableConcept: 'CodeableConcept',
  coding: 'Coding',
  reference: 'Reference',
} as const;
